module.exports = __webpack_public_path__ + "img/homework-report-icon.236401a2.svg";